import { hasLicense, isPWC, isSuperAdmin } from "@common/utils/user";
import { AuthenticatedUser } from "@services/user/types";
import { getPathPermissionKey } from "./getPathPermissionKey";
import { hasNoPermission } from "./hasNoPermission";
import { hasNoReportLicenses } from "./hasNoReportLicenses";
import { hasNoPermissionToViewReport } from "./hasNoPermissionToViewReport";
import { hasNoPermissionToViewAnalyticsReport } from "./hasNoPermissionToViewAnalyticsReport";
import { hasNoPermissionToViewAccountConfig } from "./hasNoPermissionToViewAccountConfig";
import { hasNoPermissionToViewGlobalConfigPath } from "./hasNoPermissionToViewGlobalConfigPath";

export const hasNoPermissionToViewPage = (
  path: Location["pathname"],
  user: AuthenticatedUser
) => {
  if (hasNoPermissionToViewAccountConfig(path, user)) return true;

  if (hasNoPermissionToViewGlobalConfigPath(path, user)) return true;

  const pathPermissionKey = getPathPermissionKey(path);

  if (!pathPermissionKey) return false;

  if (hasNoPermission(user, pathPermissionKey)) return true;

  switch (pathPermissionKey) {
    case "meetings": {
      return !hasLicense(user.account, "premier") || isPWC(user);
    }

    case "reports": {
      return (
        hasNoReportLicenses(user.account) ||
        hasNoPermissionToViewReport(user, path)
      );
    }

    case "analyticsReports": {
      return (
        !hasLicense(user.account, "analytics") ||
        hasNoPermissionToViewAnalyticsReport(user, path)
      );
    }

    default:
      return false;
  }
};
